<template>
  <div>
    <!-- 新增固件Dialog -->
    <el-dialog  :close-on-click-modal="false" title="新增固件" :visible.sync="dialogFormVisible" width="30%" v-if="dialogFormVisible" :append-to-body="true" :before-close="closeDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="固件类型"  :required="true">
          <el-button :type="allAttr ? 'primary' : '' " @click="clickHandler('all')">整包</el-button>
          <el-button :type="diffAttr ? 'primary' : '' " @click="clickHandler('diff')">差分</el-button>
        </el-form-item>
        <el-form-item label="固件名称" prop="firmwareName" >
          <el-input v-model.trim="ruleForm.firmwareName"  placeholder="请输入固件名称"> </el-input>
        </el-form-item>
        <el-form-item label="所属产品" prop="productKey" >
          <el-select
            filterable
            allow-create
            default-first-option
            v-model="ruleForm.productKey"
            @change="getProductName"
            placeholder="请选择固件所属产品"
            style="width:100%">
              <el-option
                v-for="item in options"
                :key="item.productId"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="固件模块" :required="true">
          <el-row class="item-items">
            <el-form-item prop="radio">
              <el-radio v-model="radio" label="1">选择模块</el-radio>
              <el-radio v-model="radio" label="2">新增模块</el-radio>
              <!-- <span style="color:red;font-size:10px" v-if="ruleForm.productKey === ''?true:false">请先选择所属产品才能选择模块</span> -->
            </el-form-item>
          </el-row>
          <el-row class="item-items">
            <el-form-item v-if="radio === '1'" prop="selectModule" class="item-items">
              <el-select
                v-model="ruleForm.module"
                style="width:100%"
                :disabled ="flag"
                placeholder="请选择固件模块"
                @focus="moduleListFocus">
                <el-option
                  v-for="item in firmwareModuleList"
                  :key="item.id"
                  :label="item.moduleName"
                  :value="item.moduleName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-else prop="addModule">
              <el-input v-model="ruleForm.addModule"  placeholder="请填写固件模块"></el-input>
            </el-form-item>
          </el-row>
        </el-form-item>
        <el-form-item label="固件版本号" prop="destVersion" v-if="typeFlag">
          <el-input v-model.trim="ruleForm.destVersion" placeholder="请输入固件版本号"></el-input>
        </el-form-item>
        <!-- 选择差分的时候显示下面两个 -->
        <el-form-item label="待升级版本号" prop="sourceVersion"  v-if="!typeFlag">
          <el-input v-model="ruleForm.sourceVersion" placeholder="请输入或选择升级版本号"></el-input>
        </el-form-item>
        <el-form-item label="升级后版本号" prop="updatedDestVersion"  v-if="!typeFlag">
          <el-input v-model="ruleForm.updatedDestVersion" placeholder="版本号需与实际固件版本号保持一致"></el-input>
        </el-form-item>
        <el-form-item label="签名算法" prop="signMethod" >
          <el-select v-model="ruleForm.signMethod" :disabled="uploadStatus" @change="selChange" style="width:100%">
            <el-option label="Md5" value="0"></el-option>
            <el-option label="SHA256" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择固件" prop="firmwareUrl" >
          <!-- <el-button size="small" type="" @click="selectFile('file')">点击上传</el-button> -->
          <el-upload
            ref="upload"
            name="file"
            action="bb"
            :before-remove="beforeRemove"
            :on-change="handleChange"
            :auto-upload="false"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <!-- <el-upload
          ref="upload"
            name="file"
            action="bb"
            :auto-upload="false"
            :on-change="handleChange"
             accept=".zip,.gz,.rar,.7z,.apk,.bin,.tar,.tar.gz,.gzip"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload> -->
          <div v-if="uploadStatus">
            {{uploadText}}
            <el-progress :color="uploadError?'rgb(255, 73, 73)':''" :percentage="hashProgress.uploadSuccess"  :format="format" ></el-progress>
          </div>
        </el-form-item>
        <el-form-item label="固件图片" prop="firmwareStatistics">
          <uploadPicView :data="imgKey" />
        </el-form-item>
        <el-form-item label="固件描述" prop="firmwareDesc">
          <el-input type="textarea" v-model="ruleForm.firmwareDesc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
          <el-button :disabled="uploadStatus" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  otaUpLoadFile,
  otaCheckUploadFile,
  otaMergeRequest,
  getServiceId,
  getUploadId
} from '@/api/fileServer'
import { getModule, addFirmware } from '@/api/productControl'
import { sliceUpload } from '@/assets/js/sliceUpload'
import { mapGetters } from 'vuex'
import uploadPicView from '@/components/product_control/addProductDialog/uploadPicView'
export default {
  components: {
    uploadPicView
  },
  props: {
    dialogFormVisible: {
      type: Boolean
    },
    options: {
      type: Array
    }
  },
  data () {
    const fileNumber = (rule, value, callback) => {
      if (this.$refs.upload.uploadFiles.length === 0) {
        callback(new Error('请选择文件！'))
      } else {
        callback()
      }
    }
    return {
      token: localStorage.getItem('authorization'),
      ruleForm: {
        firmwareType: '0', // 固件类型  差分1/整包0
        firmwareName: '', // 固件名
        productName: '', // 产品类型
        productKey: '', // 产品唯一标示
        module: 'default', // 选择模块
        addModule: '', // 添加模块
        destVersion: '', // 固件版本号 跟 升级后的版本号
        sourceVersion: '', // 需要升级的版本号
        signMethod: '0', // 签名算法
        firmwareUrl: '', // 上传文件返回的地址
        firmwareDesc: '', // 固件描述  不是必须
        firmwareSize: '', // 固件大小
        firmwareSign: '' // 固件签名  通过下拉框选择对应的值
      },
      rules: {
        firmwareName: [
          { required: true, message: '请输入固件名称', trigger: 'blur' }
        ],
        productKey: [
          { required: true, message: '请选择产品类型', trigger: 'change' }
        ],
        module: [
          { required: true, message: '请选择固件模块', trigger: 'change' }
        ],
        addModule: [
          { required: true, message: '请填写固件模块', trigger: 'blur' }
        ],
        destVersion: [
          { required: true, message: '请输入固件版本号', trigger: 'blur' }
        ],
        sourceVersion: [
          { required: true, message: '请输入或者选择待升级版本号', trigger: 'blur' }
        ],
        updatedDestVersion: [
          { required: true, message: '请输入固件版本号,注：版本好需与实际固件版本号一致', trigger: 'blur' }
        ],
        signMethod: [
          { required: true, message: '请选择签名算法', trigger: 'change' }
        ],
        firmwareUrl: [
          { required: true, validator: fileNumber, trigger: 'change' }
        ]
      },
      allAttr: true, // 动态添加btn属性
      diffAttr: false, // 动态添加btn属性
      typeFlag: true, // dialog类型选择按钮
      radio: '1', // 单选框
      fileList: [],
      firmwareModuleList: [],
      flag: true, // flag 下拉开关
      addFirmwareParams: null,
      isShow: false,
      hashProgress: {
        uploadSuccess: 0// 表示准备完成多少
      },
      uploadStatus: false,
      uploadError: false,
      serviceId: '', // 服务id
      uploadProgress: {},
      showReUpload: false, // 表示是否已经弹窗重试上传
      uploadId: '', // 上传id
      imgKey: {
        fileToken: '',
        validate: true
      }
    }
  },
  watch: {
    dialogFormVisible () {
      if (!this.dialogFormVisible) {
        sliceUpload.dialogFormVisible = false// 修改为false，中断计算
        this.uploadStatus = false
        this.$refs.ruleForm.resetFields()
        this.resetProgress()
      }
    }
  },
  computed: {
    uploadText () {
      let text
      if (this.hashProgress.uploadSuccess <= 30) {
        text = '上传准备中'
      } else if (this.hashProgress.uploadSuccess < 100) {
        text = '正在上传'
      } else if (this.hashProgress.uploadSuccess >= 100) {
        text = '上传完成'
      }
      return text
    },
    ...mapGetters(['getFileServiceId'])
  },
  created () {
  },
  methods: {
    selChange (val) {
      // if (this.uploadStatus) {
      //   this.$message({
      //     type: 'error',
      //     message: '文件正在上传，不可修改'
      //   })
      //   return
      // }
      // 重置清除上传的文件
      this.$refs.upload.clearFiles()
      this.resetProgress()
    },
    format (percentage) {
      return `${percentage}%`
    },
    async getServiceId () {
      await getServiceId().then(res => {
        res = res.data
        // console.log('servieceid==res:', res)
        if (res.code === 200) {
          this.serviceId = res.data
          this.$store.commit('SET_FILE_SERVICE_ID', res.data)
        } else {
          this.$message({
            type: 'error',
            message: '服务id获取失败'
          })
        }
      })
    },
    // 一个切片重试失败三次，整体全部终止
    async sendRequest (chunks, limit = 4) {
      let endTime
      const beginTime = new Date().getTime()
      console.log('上传分片开始：', beginTime)
      // limit并发数
      // 一个数组,长度仕limit
      let uploadPrecent = 0// 整体的上传进度
      // 用于保存上传进度
      this.uploadProgress = {}
      chunks.forEach(item => {
        this.uploadProgress[item.index] = { progress: 0, error: 0 }
      })
      const that = this
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
        const len = chunks.length
        let counter = 0
        let isStop = false
        const start = async () => {
          if (isStop) {
            return
          }
          const task = chunks.shift()
          if (task) {
            const { form } = task

            try {
              console.log('form-----', form)
              const params = {
                data: form,
                onUploadProgress: (progress) => {
                  // console.log('上传进度：', progress)
                  // 不是整体的进度条了，而是每个区块有自己的进度条，整体的进度条需要计算
                  const precent = Number(((progress.loaded / progress.total) * 100).toFixed(1))
                  that.uploadProgress[task.index].progress = precent
                  uploadPrecent = 0
                  // 循环获取整体的上传进度
                  Object.keys(that.uploadProgress).forEach(index => {
                    uploadPrecent += that.uploadProgress[index].progress
                  })
                  // uploadPrecent = Number(uploadPrecent) + Number(precent)

                  const progressPrecent = ((uploadPrecent * 0.7 + 30) / (Object.keys(that.uploadProgress).length * 100) * 100).toFixed(1)
                  // console.log('progressPrecent:', progressPrecent)
                  that.hashProgress.uploadSuccess = progressPrecent > 100 ? 100 : Number(progressPrecent)
                },
                headers: {
                  'file-service-id': this.serviceId,
                  'Content-Type': 'multipart/form-data'
                }
              }
              await otaUpLoadFile(params).then(res => {
                that.uploadProgress[task.index].error = 0
                that.uploadError = false
                // console.log('切片上传返回：', res)
              }, e => {
                // 报错时候将进度条显示为红色
                that.uploadError = true
                that.uploadProgress[task.index].error = 1 // 表示上传出错
                if (task.error < 3) {
                  task.error++
                  chunks.unshift(task)
                  start()
                } else {
                  // 错误三次
                  isStop = true
                  if (!that.showReUpload) {
                    that.confirmUpload()
                  }
                  reject(e)
                }
              })
              if (counter === len - 1) {
                endTime = new Date().getTime()
                console.log('上传分片结束：', endTime)
                console.log('上传分片耗时：', (endTime - beginTime) / 1000, '秒')
                // 最后一个任务
                resolve()
              } else {
                counter++
                // 启动下一个任务,如果关闭了就不再继续
                if (this.dialogFormVisible) {
                  start()
                }
              }
            } catch (e) {
              that.uploadProgress[task.index].error = 1 // 表示上传出错
              if (task.error < 3) {
                task.error++
                chunks.unshift(task)
                start()
                // setTimeout(function () {
                //   start()
                // }, 1000)
              } else {
                // 错误三次
                isStop = true
                that.uploadProgress[task.index].error = 1 // 表示上传出错
                if (!that.showReUpload) {
                  that.confirmUpload()
                }
                reject(e)
              }
            }
          }
        }

        while (limit > 0) {
          // 启动limit个任务
          // 模拟一下延迟
          // setTimeout(() => {
          //   start()
          // }, Math.random() * 3000)
          start()
          limit -= 1
        }
      })
    },
    // 是否再次发起上传请求
    confirmUpload () {
      this.showReUpload = true
      this.$confirm('上传出错，是否重试?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.startUpload(this.uploadingFile, this.hash)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        })
      })
    },
    // 上传切片
    async uploadChunks (uploadedList = [], chunks) {
      console.log('chunks', chunks)
      const requests = chunks
        .filter(chunk => !uploadedList.includes(chunk.name))
        .map((chunk, index) => {
          // 转成promise
          const form = new FormData()
          form.append('uploadId', chunk.uploadId)
          form.append('chunk', chunk.chunk)
          // form.append('md5', chunk.hash)
          form.append('name', chunk.name)
          // form.append('dir', 'ota/firmware')
          // form.append('signMethod', this.ruleForm.signMethod)
          return { form, index: chunk.index }
        })
        // TODO 错误重试
        // .map(({ form, index }) => {
        //   const params = {
        //     data: form,
        //     onUploadProgress: (progress) => {
        //       console.log('上传进度：', progress)
        //       console.log('index:', index)
        //       // 不是整体的进度条了，而是每个区块有自己的进度条，整体的进度条需要计算
        //       // const precent = Number(((progress.loaded / progress.total) * 100).toFixed(2))
        //       // chunks[index].progress = precent
        //       // uploadPrecent = Number(uploadPrecent) + Number(precent)
        //       // const progressPrecent = (uploadPrecent / (chunks.length * 100) * 100).toFixed(2)
        //       // that.hashProgress.uploadSuccess = progressPrecent > 100 ? 100 : Number(progressPrecent)
        //     },
        //     headers: {
        //       'file-service-id': this.serviceId,
        //       'Content-Type': 'multipart/form-data'
        //     }
        //   }
        //   otaUpLoadFile(params).then(res => {
        //     // that.uploadError = false
        //     console.log('切片上传返回：', res)
        //   }, () => {
        //     // 报错时候将进度条显示为红色
        //     // that.uploadError = true
        //   })
        // })
      // @todo 并发量控制
      // 尝试申请tcp链接过多，也会造成卡顿
      // 异步的并发数控制，
      // await Promise.all(requests)
      if (requests.length > 0 && this.dialogFormVisible) { // 当有需要上传的切片才需调用上传接口
        await this.sendRequest(requests)
      }
      // await Promise.all(requests)
    },
    selectFile (id) {
      document.getElementById(id).click()
    },
    // 获取产品名字
    getProductName (val) {
      
      this.firmwareModuleList = []
      this.ruleForm.productKey = val
      this.flag = false
      const optionName = this.options.find(item => {
        return (item.productKey === val)
      })
      this.ruleForm.productName = optionName.productName
      // 获取模块列表
      const params = {
        params: {
          productKey: this.ruleForm.productKey
        }
      }
      getModule(params)
        .then(res => {
          console.log(123123)
          if (res.data.data.length === 0) {
            this.firmwareModuleList = [
              {
                moduleName: 'default'
              }
            ]
          }
          this.firmwareModuleList = [...this.firmwareModuleList, ...res.data.data]
        })
    },
    // 重置进度条
    resetProgress () {
      this.ruleForm.firmwareUrl = ''
      Object.assign(this.hashProgress, {
        uploadSuccess: 0// 表示准备完成多少
      })
    },
    async startUpload (file, currentHash) {
      this.uploadError = false
      console.log('file', file)
      sliceUpload.dialogFormVisible = true// 重置为可计算状态
      this.showReUpload = false
      const CHUNK_SIZE = 5 * 1024 * 1024
      // 获取服务id, 与分片上传相关的接口都需要在请求头中添加file-service-id(请求头名)
      this.serviceId = this.getFileServiceId
      if (!this.serviceId) {
        await this.getServiceId()
      }
      // 文件切片
      const chunks = sliceUpload.createFileChunk(file, CHUNK_SIZE)
      // 计算md5值，（后续可以做秒传）
      let hash
      if (currentHash) {
        hash = currentHash
      } else {
        // hash = await sliceUpload.calculateHashLoop(chunks, this.hashProgress, this.ruleForm.signMethod, this.dialogFormVisible)
        if (window.requestIdleCallback) {
          hash = await sliceUpload.calculateHashIdle(chunks, this.hashProgress, this.ruleForm.signMethod)
        } else {
          // hash = await sliceUpload.calculateHashSample(file, this.hashProgress, this.ruleForm.signMethod)
          hash = await sliceUpload.calculateHashLoop(chunks, this.hashProgress, this.ruleForm.signMethod)
        }
      }
      console.log('计算后的hash值:', hash)
      if (hash === false) {
        return
      }
      this.hash = hash
      this.ruleForm.firmwareSize = file.size
      this.ruleForm.firmwareSign = hash
      // 问一下后端，文件是否上传过，如果没有，是否有存在的切片（uploadedList表示已经上传成功的文件切片）
      // let uploaded = ''
      let uploadedList = []
      // let uploadId = ''
      // let fileInfo = ''
      const requestParams = { // TODO:
        params: {
          /* hash: hash,
          sliceNum: chunks.length,
          fileName: file.name */
          // md5: hash,
          // fileName: file.name,
          // dir: 'ota/firmware'
          uploadId: this.uploadId
        },
        headers: {
          'file-service-id': this.serviceId
        }
      }
      const that = this
      let getChckFileMes = false// 不出错获取到信息才进行下一步
      await otaCheckUploadFile(requestParams).then(res => {
        getChckFileMes = true
        res = res.data
        // console.log('检查返回的数据：', res)
        // uploaded = res.data.uploaded
        uploadedList = res.data.uploadedList
        // uploadId = res.data.uploadId
        // fileInfo = res.data.fileInfo
      }).then(() => {

      }, async error => {
        // serviceId过期了，需要重新请求获取
        if (error.response && error.response.status === 503) {
          // 刷新serviceId
          await that.getServiceId()
          // 更新serviceId 更新params
          that.serviceId = that.$store.getters.getFileServiceId
          requestParams.headers['file-service-id'] = that.serviceId
          // 重新checkFile
          await otaCheckUploadFile(requestParams).then(res => {
            getChckFileMes = true
            res = res.data
            // uploaded = res.data.uploaded
            uploadedList = res.data.uploadedList
            // uploadId = res.data.uploadId
            // fileInfo = res.data.fileInfo
          }).catch(async res => {
            await that.confirmUpload()
          })
        }
      })
      if (!getChckFileMes) {
        return
      }
      // if (uploaded) {
      //   this.uploadStatus = false
      //   this.hashProgress.uploading = true
      //   this.hashProgress.uploadSuccess = 100
      //   this.ruleForm.firmwareUrl = fileInfo.pathKey
      //   // 秒传
      //   return this.$message.success('秒传成功')
      // }

      // 切片上传
      this.chunks = chunks.map((chunk, index) => {
        // 切片的名字 hash+index
        const name = this.uploadId + '-' + index
        return {
          // hash,
          name,
          uploadId: this.uploadId,
          index,
          chunk: chunk.file,
          // 设置进度条，已经上传的，设为100
          progress: uploadedList.indexOf(name) > -1 ? 100 : 0
        }
      })
      await this.uploadChunks(uploadedList, this.chunks)
      // 在窗口打开的情况下再请求合并
      if (this.dialogFormVisible) {
        await this.mergeFile()
      }
    },
    async mergeFile () {
      const file = this.uploadingFile
      // 是否请求合并
      let requestMerge = true
      Object.keys(this.uploadProgress).forEach(index => {
        if (this.uploadProgress[index].error) {
          requestMerge = false
        }
      })
      if (requestMerge) {
        const mergeParams = {
          params: {
            size: file.size,
            md5: this.hash,
            fileName: file.name,
            signMethod: this.ruleForm.signMethod,
            uploadId: this.uploadId
          },
          headers: {
            'file-service-id': this.serviceId
          }
        }

        await otaMergeRequest(mergeParams).then(res => {
          this.uploadStatus = false
          res = res.data
          // console.log('合并文件返回：', res)
          if (res.code === 200) {
            console.log('res.data', res.data)
            if (res.data) {
              this.hashProgress.uploadSuccess = 100
              this.ruleForm.firmwareUrl = res.data.pathKey
              return this.$message.success('文件上传成功')
            }
          }
        }, () => {
          // console.log('合并报错this：', this)
          this.uploadError = true
        })
      }
    },
    beforeRemove () {
      this.uploadStatus = false
      this.resetProgress()
    },
    async handleChange (selFile, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.uploadStatus = true
      this.resetProgress()
      const file = selFile.raw
      if (!file) { return }
      if (file.size > 1024 * 1024 * 2048) {
        this.$message({
          type: 'error',
          message: '上传文件大小超过2G'
        })
        return false
      }
      this.uploadingFile = file// 把要上传的文件进行保存，后续出错重试上传可以用

      // 获取分片上传的文件夹id
      const params = {
        fileName: selFile.name,
        dir: 'ota/firmware/'
      }
      this.uploadId = ''
      await getUploadId(params).then(res => {
        res = res.data
        this.uploadId = res.data
        console.log('获取上传id：', res.data)
      })

      // 开始上传
      this.startUpload(file)
      return false
      // 旧代码
      // const that = this
      // that.ruleForm.firmwareSize = file.size
      // const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      // const fileReader = new FileReader()
      // const chunkSize = 1024 * 1024 * 5
      // const chunks = Math.ceil(file.size / chunkSize)
      // let currentChunk = 0
      // // 注意点，网上都是 这一步都是有问题的， SparkMD5.ArrayBuffer()
      // const spark = new SparkMD5.ArrayBuffer()
      // fileReader.onload = function (e) {
      //   spark.append(e.target.result)
      //   currentChunk++
      //   if (currentChunk < chunks) {
      //     loadNext()
      //   } else {
      //     const sparkEnd = spark.end()
      //     // 计算后的结果
      //     that.ruleForm.firmwareSign = sparkEnd
      //     console.log('computed hash', sparkEnd)
      //   }
      // }
      // fileReader.onerror = function () {
      //   console.warn('FileReader error.')
      // }
      // function loadNext () {
      //   const start = currentChunk * chunkSize
      //   const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
      //   // 注意这里的 fileRaw
      //   fileReader.readAsArrayBuffer(blobSlice.call(file.raw, start, end))
      // }
      // loadNext()

      // if (fileList.length > 1) {
      //   fileList.splice(0, 1)
      // }
    },
    // 提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { // 验证成功
          this.addFirmwareParams = Object.assign({}, this.ruleForm)
          console.log('this.addFirmwareParams', this.addFirmwareParams)
          // 添加ProduckName
          for (const item of this.options) {
            if (this.ruleForm.productKey === item.productKey) {
              this.addFirmwareParams.productName = item.productName
              break
            }
          }
          delete this.addFirmwareParams.addModule
          if (this.radio === '2') {
            this.addFirmwareParams.module = this.ruleForm.addModule
          }
          if (this.allAttr === false) {
            this.addFirmwareParams.destVersion = this.ruleForm.updatedDestVersion // 差分选择升级后的版本号
          }
          // 添加固件
          const params = {
            params: Object.assign({}, this.addFirmwareParams, { signMethod: this.addFirmwareParams.signMethod === '0' ? 'Md5' : 'SHA256' })
          }
          if (this.imgKey.fileToken) {
            params.params.firmwareImgKey = this.imgKey.fileToken
          }
          console.log('params----', params)
          addFirmware(params).then((res) => { // TODO:----优化
            if (res.data.code === 200) {
              this.$message.success('添加成功')
              this.resetProgress()
              this.$emit('closeDialog', 1)
              this.flag = true
              this.allAttr = true
              this.diffAttr = false
              this.ruleForm.module = 'default'
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
          })
        } else {
          this.$message.error('请完善信息后再试')
          this.addFirmwareParams = Object.assign({}, this.ruleForm)
          delete this.addFirmwareParams.addModule
          return false
        }
      })
    },
    // 重置
    resetForm (formName) {
      if (!this.uploadStatus) {
        // 重置清除上传的文件
        this.$refs.upload.clearFiles()
        this.resetProgress()
        this.allAttr = true
        this.diffAttr = false
        this.$refs[formName].resetFields()
      }
    },
    // 固件类型按钮
    clickHandler (val) {
      if (val === 'all') {
        this.typeFlag = true
        this.allAttr = true
        this.diffAttr = false
        this.ruleForm.firmwareType = '0'
      }
      if (val === 'diff') {
        this.typeFlag = false
        this.allAttr = false
        this.diffAttr = true
        this.ruleForm.firmwareType = '1'
      }
    },
    // 模块下拉聚焦时
    moduleListFocus () {

    },
    closeDialog () {
      if (this.uploadStatus) {
        this.$confirm('是否中断上传并退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.resetProgress()
          this.$emit('closeDialog')
        })
      } else {
        this.allAttr = true
        this.diffAttr = false
        this.resetProgress()
        this.$emit('closeDialog')
      }
    }
  }
}
</script>

<style lang='less' scoped>

</style>
